import React from "react";
import { Camera, Wrench, Sparkles, Hammer, Laptop, Palette, Truck, PartyPopper } from "lucide-react";
import { toast } from "sonner";

const SERVICES = [
  { icon: Camera, name: "Photography & Video", desc: "Weddings, events, product shoots and real estate across Jamaica.", from: 25000 },
  { icon: Wrench, name: "Repairs & Maintenance", desc: "Appliance, electronics and home repairs by verified technicians.", from: 4500 },
  { icon: Sparkles, name: "Cleaning Services", desc: "Home, office and post-construction deep cleaning.", from: 6000 },
  { icon: Hammer, name: "Construction & Trades", desc: "Masons, plumbers, electricians and general contractors.", from: 15000 },
  { icon: Laptop, name: "Technology Services", desc: "IT support, networking, POS setup and web development.", from: 12000 },
  { icon: Palette, name: "Design & Branding", desc: "Logos, print, signage and social media content.", from: 18000 },
  { icon: Truck, name: "Airport Transfers", desc: "Private transfers between MBJ/KIN airports and your stay.", from: 8000 },
  { icon: PartyPopper, name: "Event Services", desc: "Catering, décor, sound and full event management.", from: 40000 },
];

export default function Services() {
  return (
    <div>
      <section className="sn-hero-mesh sn-noise text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 relative">
          <span className="inline-flex items-center gap-2 sn-glass sn-pill px-4 py-1.5 text-xs font-semibold uppercase tracking-wider">Local Services</span>
          <h1 className="font-clash font-bold text-4xl sm:text-5xl mt-4">Book trusted professionals.</h1>
          <p className="text-white/70 mt-3 max-w-xl">From photographers to plumbers — book vetted Jamaican service providers through SHOP NOW's unified booking engine.</p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s) => (
            <div key={s.name} className="bg-card rounded-2xl border border-border p-6 sn-card-hover">
              <span className="h-12 w-12 rounded-xl bg-emerald/10 text-emerald grid place-items-center mb-4"><s.icon size={22} /></span>
              <h3 className="font-display font-bold">{s.name}</h3>
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{s.desc}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-sm">from <span className="font-display font-bold text-ink">J${s.from.toLocaleString()}</span></span>
                <button onClick={() => toast.success(`Request sent for ${s.name}. A provider will contact you shortly.`)} className="text-sm font-semibold text-white bg-ink rounded-lg px-3 py-1.5 hover:bg-emerald-deep transition-colors" data-testid="service-book-btn">Request</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
